import React, { useState } from 'react';
import { submissions, studentGoals } from '../utils/mockData';
import { CheckIcon, XIcon, MessageCircleIcon } from 'lucide-react';
const ReviewSubmissionsPage: React.FC = () => {
  const [pendingSubmissions, setPendingSubmissions] = useState(submissions.filter(sub => sub.status === 'pending'));
  const [feedbackText, setFeedbackText] = useState('');
  const [pointsToAward, setPointsToAward] = useState(10);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [currentSubmission, setCurrentSubmission] = useState<string | null>(null);
  const [isApproving, setIsApproving] = useState(false);
  const handleReviewClick = (submissionId: string, approve: boolean) => {
    setCurrentSubmission(submissionId);
    setIsApproving(approve);
    setShowFeedbackModal(true);
    // Reset form
    setFeedbackText('');
    setPointsToAward(approve ? 10 : 0);
  };
  const handleSubmitReview = () => {
    // In a real app, you would send this to the server
    console.log('Submitting review:', {
      submissionId: currentSubmission,
      approved: isApproving,
      feedback: feedbackText,
      points: isApproving ? pointsToAward : 0
    });
    // Update local state to remove the reviewed submission
    setPendingSubmissions(prev => prev.filter(sub => sub.id !== currentSubmission));
    // Close modal
    setShowFeedbackModal(false);
    setCurrentSubmission(null);
    // Show success message
    alert(isApproving ? '已通过该提交并发放积分' : '已拒绝该提交并发送反馈');
  };
  return <div className="max-w-5xl mx-auto" data-id="element-840">
      <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-841">审核学生提交</h1>
      {pendingSubmissions.length > 0 ? <div className="space-y-6" data-id="element-842">
          {pendingSubmissions.map(submission => {
        const goal = studentGoals.find(g => g.id === submission.goalId);
        return <div key={submission.id} className="bg-white rounded-lg shadow p-6" data-id="element-843">
                <div className="flex justify-between items-start mb-4" data-id="element-844">
                  <div data-id="element-845">
                    <span className="inline-block px-2 py-1 text-xs rounded-full bg-yellow-100 text-yellow-800 mb-2" data-id="element-846">
                      待审核
                    </span>
                    <h2 className="text-xl font-medium text-gray-800" data-id="element-847">
                      {goal?.title}
                    </h2>
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-848">
                    提交时间: {submission.submittedAt}
                  </div>
                </div>
                <div className="mb-6" data-id="element-849">
                  <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-850">
                    目标描述
                  </h3>
                  <p className="text-gray-800" data-id="element-851">{goal?.description}</p>
                </div>
                <div className="mb-6" data-id="element-852">
                  <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-853">
                    学生
                  </h3>
                  <p className="text-gray-800" data-id="element-854">{submission.studentName}</p>
                </div>
                <div className="mb-6" data-id="element-855">
                  <h3 className="text-sm font-medium text-gray-500 mb-1" data-id="element-856">
                    完成说明
                  </h3>
                  <p className="text-gray-800" data-id="element-857">{submission.content}</p>
                </div>
                {submission.evidence && <div className="mb-6" data-id="element-858">
                    <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-859">
                      完成证明
                    </h3>
                    <img src={submission.evidence} alt="完成证明" className="max-h-64 rounded-lg" data-id="element-860" />
                  </div>}
                <div className="flex justify-end space-x-4" data-id="element-861">
                  <button onClick={() => handleReviewClick(submission.id, false)} className="flex items-center px-4 py-2 border border-red-300 text-red-700 rounded-lg hover:bg-red-50" data-id="element-862">
                    <XIcon size={18} className="mr-2" data-id="element-863" />
                    未通过
                  </button>
                  <button onClick={() => handleReviewClick(submission.id, true)} className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700" data-id="element-864">
                    <CheckIcon size={18} className="mr-2" data-id="element-865" />
                    通过
                  </button>
                </div>
              </div>;
      })}
        </div> : <div className="bg-white rounded-lg shadow p-8 text-center" data-id="element-866">
          <h2 className="text-xl font-medium text-gray-800 mb-2" data-id="element-867">
            没有待审核的提交
          </h2>
          <p className="text-gray-600" data-id="element-868">所有学生提交都已审核完毕</p>
        </div>}
      {/* Feedback Modal */}
      {showFeedbackModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-869">
          <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full" data-id="element-870">
            <h2 className="text-xl font-medium text-gray-800 mb-4 flex items-center" data-id="element-871">
              {isApproving ? <>
                  <CheckIcon size={20} className="text-green-600 mr-2" data-id="element-872" />
                  通过提交
                </> : <>
                  <XIcon size={20} className="text-red-600 mr-2" data-id="element-873" />
                  拒绝提交
                </>}
            </h2>
            <div className="mb-4" data-id="element-874">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-875">
                <MessageCircleIcon size={16} className="inline mr-1" data-id="element-876" />
                反馈意见
              </label>
              <textarea value={feedbackText} onChange={e => setFeedbackText(e.target.value)} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" rows={3} placeholder="给学生的反馈意见..." data-id="element-877" />
            </div>
            {isApproving && <div className="mb-6" data-id="element-878">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-879">
                  发放积分
                </label>
                <input type="number" min="0" max="100" value={pointsToAward} onChange={e => setPointsToAward(parseInt(e.target.value) || 0)} className="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" data-id="element-880" />
              </div>}
            <div className="flex justify-end space-x-3" data-id="element-881">
              <button onClick={() => setShowFeedbackModal(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50" data-id="element-882">
                取消
              </button>
              <button onClick={handleSubmitReview} className={`px-4 py-2 rounded-lg text-white ${isApproving ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'}`} data-id="element-883">
                确认
              </button>
            </div>
          </div>
        </div>}
    </div>;
};
export default ReviewSubmissionsPage;